import React from "react";
import Headline from "../gd/Headline";
import { Button, Col, Flex, Form, FormInstance, Input, notification, Row, Select, Space } from "antd";
import ContactUsApi from "../../api-services/contact-us-api.service";
import HomeLink from "../../widgets/HomeLink";
import Cookies from "js-cookie"
import ListApi from "../../api-services/list-api.service";

const { TextArea } = Input;

const customCookies = Cookies.withAttributes({
  expires: 14
});

const bannerPath = '/iceholidays-assets/images/contact_us_gd_cover.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'Contact Us' }
] 


const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '${label} is not a valid email!',
    number: '${label} is not a valid number!',
  },
  number: {
    range: '${label} must be between ${min} and ${max}',
  },
};


export default class ContactUsPage extends React.Component {
  api = new ContactUsApi;
  listApi = new ListApi;
  contactForm = React.createRef<FormInstance>();

  state = {
    states: []
  }


  componentDidMount() {
    const storedStates = customCookies.get("states");

    Promise.all([
      storedStates == undefined ? this.listApi.getStates() : JSON.parse(storedStates)
    ]).then(([states]) => {
        customCookies.set('states', JSON.stringify(states))

        this.setState({states})
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading states.'});
      });
  }

  submitForm(formValues) {
    this.api.contactInquiry(formValues)
      .then(success => {
        if(success){
          notification['success']({message: "Inquiry sent."});
          this.contactForm.current?.resetFields();
        }
      })
      .catch(error => {
        notification.error({ message: 'An error occured while sending inquiry.'});
      });
  }

  render(){
    return (
      <div id="contact-us-page" className="more-page">
        <Headline showSearch={false}  bannerImage={bannerPath} breadcrumbs={breadcrumbs} title="Contact Us"/>
  
        <div className="more-page_body">
          <div className="more-page_content">
            <Space size={40} direction="vertical">
              <div id="contact-us-note">
                <h2>Contact Us</h2>
                <p>Have a feedback or suggestion? Contact us @ <a href="/">feedback@gd.my</a></p>
              </div>
              <hr/>
              <div id="contact-us-form">
                <div id="contact-us-form_header">
                  <h2>Get in touch</h2>
                  <span>Send us your enquiry</span>
                </div>
                <Form
                  ref={this.contactForm}
                  autoComplete="off"
                  layout="vertical"
                  variant="filled"
                  validateMessages={validateMessages}
                  onFinish={(formValues)=>this.submitForm(formValues)}
                >

                  <Space size={40} direction="vertical">
                    <div>
                      <h3>Personal Details</h3>      
                      <Row gutter={20}>
                        <Col xs={24} sm={12} lg={12}>
                          <Form.Item label="Name" name="name">
                            <Input placeholder="Enter Name" />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} lg={12}>
                          <Form.Item label="Email" name="email" rules={[{ type: 'email' }]} required>
                            <Input placeholder="Enter Email" />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row gutter={20}>
                        <Col xs={24} sm={12} lg={12}>
                          <Form.Item label="Phone Number" name="phone" required>
                            <Input placeholder="Enter Phone Number" />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} lg={12}>    
                          <Form.Item label="State" name="state">
                            <Select
                                showSearch
                                allowClear
                                placeholder="Select State"
                                options={this.state?.states}
                              />
                          </Form.Item>
                        </Col>
                      </Row>
                                  
                      <Form.Item label="Area" name="area">
                        <Input placeholder="Select Area" />
                      </Form.Item>
                    </div>                    
                    <hr/>
                    <div>
                      <h3>Enquiry Details</h3>    
                      <Form.Item label="Subject Matter" name="subject">
                        <Input placeholder="Enter Here" />
                      </Form.Item>
          
                      <Form.Item label="Message" name="message" required>
                        <TextArea rows={4} placeholder="Write your message"/>
                      </Form.Item>
                    </div>
                  </Space>

                  <Flex align="center" justify="center">
                    <Button type="primary" htmlType="submit">
                      Submit
                    </Button>
                  </Flex>
      
                </Form>
              </div>
            </Space>
          </div>
        </div>
      </div>
    );
  }
}